import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

const SetPass = () => {
  const { type } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation: check if passwords match
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    // TODO: Integrate with your backend API to update the password.
    console.log(`Setting new password for ${type}:`, password);
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl text-black font-semibold text-center mb-6">
          Set Password
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Password Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Password *
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Confirm Password Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Confirm Password *
            </label>
            <input
              type="password"
              placeholder="Re-enter your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Submit Button */}
          <button type="submit" className="w-full bg-teal-600 text-white py-2 rounded-md hover:bg-teal-700 transition">
            Set new password
          </button>
        </form>

        {/* Sign Up Link */}
        <p className="text-center text-sm text-gray-600 mt-4">
          Don't have an account?{" "}
          <span className="text-green-600 cursor-pointer">
            <Link to={`/auth/signup/${type}`}>Signup</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default SetPass;
